import { defineStore } from "pinia";
import registry from '~/components/widgets/widget-registry';
import { User } from "~/api/models/user.model";
import { v4 as uuidv4 } from 'uuid';
import { Widget, WidgetType } from "~/models/widget.model";
import { useAuthStore } from "./auth.store";

export const useWidgetStore = defineStore('widget', {
    state: () => ({
        defaults: [
            { id: uuidv4(), height: 1, width: 3, minWidth: 2, minHeight: 1, x: 0, y: 0, type: WidgetType.AQ_CO2 } as Widget,
            { id: uuidv4(), height: 1, width: 2, minWidth: 2, minHeight: 1, x: 3, y: 0, type: WidgetType.TEMPERATURE } as Widget,
            { id: uuidv4(), height: 1, width: 2, minWidth: 2, minHeight: 1, x: 5, y: 0, type: WidgetType.HUMIDITY } as Widget,
            { id: uuidv4(), height: 1, width: 2, minWidth: 2, minHeight: 1, x: 7, y: 0, type: WidgetType.PRESSURE } as Widget,
            { id: uuidv4(), height: 1, width: 9, minWidth: 3, minHeight: 1, x: 0, y: 2, type: WidgetType.HISTOGRAM } as Widget,
            { id: uuidv4(), height: 1, width: 3, minWidth: 2, minHeight: 1, x: 0, y: 4, type: WidgetType.MAP } as Widget,
            { id: uuidv4(), height: 1, width: 3, minWidth: 2, minHeight: 1, x: 3, y: 4, type: WidgetType.MORE_INFO } as Widget,
            { id: uuidv4(), height: 1, width: 3, minWidth: 3, minHeight: 1, x: 6, y: 4, type: WidgetType.ICONE } as Widget,
            { id: uuidv4(), height: 3, width: 3, minWidth: 3, minHeight: 2, x: 9, y: 0, type: WidgetType.STATIONS } as Widget,
        ] as Widget[],
        templates: registry.getWidgetsSpecifications(),
        widgets: null as Widget[] | null,
    }),

    actions: {
        async load(): Promise<Widget[]> {
            const authStore = useAuthStore();
            const user = await authStore.fetchUser();

            if (!user?.metadata["elichens/user/app/dashboard"]?.grid?.widgets?.length) {
                this.widgets = this.defaults;
                this.saveWidgets(this.widgets);
            } else {
                this.widgets = user?.metadata["elichens/user/app/dashboard"]?.grid?.widgets;
            }

            return this.widgets;
        },

        saveWidgets(widgets: Widget[]): Promise<User> {
            const authStore = useAuthStore();
            this.widgets = widgets;
            return authStore.updateUserMetadata({
                "elichens/user/app/dashboard": {
                    grid: { widgets },
                },
            });
        },

        async reset(): Promise<User> {
            this.widgets = this.defaults;
            return this.saveWidgets(this.widgets);
        }
    }
})